<template>
  <div ref="dateRangePicker" class="date-range-picker">
    <v-menu
      v-model="dialog"
      offset-y
      :nudge-right="nudgeRight"
      max-width="328"
      content-class="content-calendar"
      :close-on-content-click="false"
      transition="scale-transition"
    >
      <template #activator="{ on, attrs }">
        <v-text-field
          :class="
            `input-date-range ${
              attrs['aria-expanded'] === 'true' ? 'active' : ''
            }`
          "
          readonly
          rounded
          dense
          solo
          hide-details
          v-bind="attrs"
          v-on="on"
          :value="displayValue"
          label="Seleccionar Fechas"
          placeholder="Seleccionar Fechas"
          append-icon="$chevronDownIcon"
          prepend-inner-icon="$calendarIcon"
        >
          <template #append>
            <v-icon class="icon-tam-20 p-0" @click.stop="dialog = !dialog">
              $chevronDownIcon
            </v-icon>
          </template>
          <template #prepend-inner>
            <v-icon class="icon-tam-20 p-0" @click.stop="dialog = !dialog">
              $calendarIcon
            </v-icon>
          </template>
        </v-text-field>
      </template>

      <v-card class="px-4 pt-6">
        <CustomCalendar
          v-model="dateRange"
          :quick-actions="customActions"
          @apply="onConfirm"
          @cancel="onCancel"
        />
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import CustomCalendar from "./CustomCalendar.vue";

export default {
  name: "DateRangePicker",
  props: {
    value: Object,
  },
  data() {
    return {
      dateRange: { start: null, end: null },
      customActions: [
        { label: "Last week", days: 7 },
        { label: "Last month", days: 30 },
        { label: "Last year", days: 365 },
      ],
      dialog: false,
      nudgeRight: 0,
    };
  },
  components: { CustomCalendar },
  computed: {
    displayValue() {
      if (!this.dateRange.start || !this.dateRange.end) return "";
      const months = [
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sep",
        "Oct",
        "Nov",
        "Dic",
      ];
      const format = (d) =>
        `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
      return `${format(this.dateRange.start)} – ${format(this.dateRange.end)}`;
    },
  },
  watch: {
    value: {
      handler(val) {
        if (!val) return;
        const newStart = val.start ? new Date(val.start) : null;
        const newEnd = val.end ? new Date(val.end) : null;

        if (
          this.dateRange.start?.getTime() !== newStart?.getTime() ||
          this.dateRange.end?.getTime() !== newEnd?.getTime()
        ) {
          this.dateRange = { start: newStart, end: newEnd };
        }
      },
      immediate: true,
      deep: true,
    },
    dateRange: {
      handler(val) {
        this.$emit("input", val);
      },
      deep: true,
    },
  },
  mounted() {
    this.observeParent();
  },
  beforeDestroy() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
  },
  methods: {
    onCancel() {
      this.dialog = false;
      if (this.value) this.dateRange = { ...this.value };
    },
    onConfirm(range) {
      this.dialog = false;
    },
    observeParent() {
      const el = this.$refs.dateRangePicker;
      if (!el) return;
      this.updateNudge(el);
      this.resizeObserver = new ResizeObserver(() => {
        this.updateNudge(el);
      });
      this.resizeObserver.observe(el);
    },
    updateNudge(el) {
      this.nudgeRight = el.offsetWidth - 328;
    },
  },
};
</script>
